import { AfterViewInit, Component, DoCheck, EventEmitter, Input, IterableDiffers, OnInit, Output, ViewChild, } from '@angular/core';
import { Subject } from 'rxjs';
import { IRowActionData } from './models/row-action-data.interface';
import { IRowColumn } from './models/row-column.interface';
import { DataTableDirective } from 'angular-datatables';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'upsc-responsive-table',
  templateUrl: './responsive-table.component.html',
  styleUrls: ['./responsive-table.component.scss'],
})
export class ResponsiveTableComponent<T> implements OnInit, AfterViewInit, DoCheck {
  @Input() public columns: IRowColumn[];
  @Input() public items: T[];
  @Input() public footerItems: string[];
  @Input() usePaginator = false;
  @Input() totalItemCount: number;
  @Input() pageSize: number;
  @Input() pageIndex = 0;
  @Input() isLoading = false;
  @Output() public rowActionClicked: EventEmitter<IRowActionData<T>> = new EventEmitter<IRowActionData<T>>();
  @Output() public pageChanged: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  @ViewChild(DataTableDirective, { static: true }) dtElement: DataTableDirective;

  public dtOptions: any = {};
  public dtTrigger = new Subject();
  public displayedColumns: T[];
  public displayedItems: T[];
  public displayedFooterItems: string[];

  private iterableItemsDiffers;
  private iterableColumnsDiffers;
  private iterableRowActionsDiffers;
  private iterableFooterItemsDiffers;

  constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableItemsDiffers = this._iterableDiffers.find([]).create(null);
    this.iterableColumnsDiffers = this._iterableDiffers.find([]).create(null);
    this.iterableRowActionsDiffers = this._iterableDiffers.find([]).create(null);
    this.iterableFooterItemsDiffers = this._iterableDiffers.find([]).create(null);
  }

  public ngOnInit() {
    this.dtOptions = {
      // retrieve: true,
      autoWidth: false,
      searching: false,
      info: false,
      paging: false,
      ordering: false,
      responsive: true,
    };
  }

  // public ngOnChanges(changes: SimpleChanges) {
  //   this.onItemsChanged(changes['items']);
  // }
  //
  // private onItemsChanged(change: SimpleChange) {
  //   if (!change || !change.currentValue) {
  //     return;
  //   }
  //
  //   if (!this.totalItemCount) {
  //     this.totalItemCount = change.currentValue.length;
  //   }
  //
  //   if (!this.pageSize) {
  //     this.pageSize = change.currentValue.length;
  //   }
  //
  //     if (this.dtElement && this.dtElement.dtInstance) {
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.displayedItems = change.currentValue;
  //         this.dtTrigger.next(null);
  //       });
  //     }
  // }

  public ngAfterViewInit() {
    this.dtTrigger.next(null);
  }

  public ngDoCheck() {
    const itemsChanges = this.iterableItemsDiffers.diff(this.items);
    if (itemsChanges) {
      if (!this.totalItemCount) {
        this.totalItemCount = itemsChanges.collection.length;
      }

      if (!this.pageSize) {
        this.pageSize = itemsChanges.collection.length;
      }

      // Don't use this method of re-rendering with the option of retrieve: true.
      // Do use it with dtTrigger.next(null) on ngAfterViewInit().
      if (this.dtElement && this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          this.displayedItems = itemsChanges.collection;
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      }

      // this.displayedItems = itemsChanges.collection;
      // this.dtTrigger.next(null);
    }

    const columnsChanges = this.iterableColumnsDiffers.diff(this.columns);
    if (columnsChanges) {
      this.displayedColumns = columnsChanges.collection;
    }

    const footerItemsChanges = this.iterableFooterItemsDiffers.diff(this.footerItems);
    if (footerItemsChanges) {
      this.displayedFooterItems = footerItemsChanges.collection;
    }
  }

  public takeAction(event, key: string, item: T) {
    event.preventDefault();

    this.rowActionClicked.emit({ key, data: item });
  }

  public onPageChanged(pageEvent: PageEvent) {
    this.pageChanged.emit(pageEvent);
  }
}
